import type { FaireOrderEntity } from "../../entity_types/order";

export const HYBYWJXJYN: FaireOrderEntity = {
  token: "HYBYWJXJYN",
  type: "order",
  orderNumber: "#HYBYWJXJYN",
  status: "new",
  totalDollars: 288,
  customerName: "Maple Street Dry Goods",
  firstOrder: true,
  placedAt: "Dec 1, 2025",
  sourceLabel: "Marketplace",
  commissionNote: "Large retailer",
  payoutDate: "Pending Ship",
  isFairePlus: true,
  isPreorder: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
